import { render, staticRenderFns } from "./AffiliateSyncConfig.vue?vue&type=template&id=46773c76"
import script from "./AffiliateSyncConfig.vue?vue&type=script&lang=js"
export * from "./AffiliateSyncConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports